import * as __SNOWPACK_ENV__ from '../_snowpack/env.js';

import axios from "../_snowpack/pkg/axios.js";
const BASE_URL = __SNOWPACK_ENV__.SNOWPACK_PUBLIC_API_URL;
export const getAllInstitutions = async () => {
  try {
    const {data} = await axios.get(`${BASE_URL}/institutions`);
    return data;
  } catch (e) {
    console.error(e);
    return e;
  }
};
export const getInstitutionWithData = async (ficeCode) => {
  try {
    const {data} = await axios.get(`${BASE_URL}/institutionswdata/${ficeCode}`);
    return data;
  } catch (e) {
    console.error(e);
    return e;
  }
};
export const getAllAnnualData = async () => {
  try {
    const {data} = await axios.get(`${BASE_URL}/annualdata`);
    return data;
  } catch (e) {
    console.error(e);
    return e;
  }
};
export const getAllNationalAverages = async () => {
  try {
    const {data} = await axios.get(`${BASE_URL}/nationalaverages`);
    return data;
  } catch (e) {
    console.error(e);
    return e;
  }
};
